import api from '../config/Api';

const endpoint = 'v1/attribute-iplusd-formula';

export default {

  getAttributeIDFormulaParams( attributeId, params ) {
    return api.get( `${endpoint}/${attributeId}`, params );
  },

  updateAttributeIDFormulaParam( id, data ) {
    return api.put( `${endpoint}/${id}`, data );
  },
};
